import React, { useContext } from 'react';
import styled from 'styled-components';
import find from 'lodash/find';

import { FieldContained } from '@ad-scripts/presentation/components/common/input_field';
import FormContext from 'src/presentation/contexts/FormContext';
import Input, { InputType } from 'src/presentation/components/forms/Input';
import { Label } from '@ad-scripts/presentation/components/common/radio_button';
import { Row } from './controls/Layout';

type NumberProps = {
  attr: string;
  disabled: boolean;
  prompt: string;
  isReversed?: boolean;
};

export default function Number({ attr, disabled, prompt, isReversed }: NumberProps) {
  const { errors } = useContext(FormContext);
  const error = find(errors, error => error.attr === attr);

  return (
    <FieldContained
      error={error}
      control={
        <StyledRow isReversed={isReversed}>
          <Label>{prompt}</Label>
          <InputContainer isReversed={isReversed}>
            <Input attr={attr} type={InputType.number} disabled={disabled} />
          </InputContainer>
        </StyledRow>
      }
    />
  );
}

const InputContainer = styled.div`
  max-width: 84px;

  margin: ${p => (p.isReversed ? '0 8px 0 0 !important' : '0')};

  input {
    text-align: right;
  }
`;

const StyledRow = styled(Row)`
  align-items: center;
  justify-content: space-between;
  width: 100%;

  flex-direction: ${p => (p.isReversed ? 'row-reverse' : 'row')};

  label {
    margin-bottom: 0;
    flex: 1;
  }
`;
